module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitleab",
    attrs: {
      "id": "ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Some people think that Fierce, Obnoxious, Odoriferous Furballs are fictional creatures. That is too bad for them, because it means that they will not be prepared in case of an actual Foof attack. I do not have that problem. I have bunions. In case you do not know what bunions are, I will tell you. Bunions are what you get when you cross bunnies with onions. That is a lie, but it does not matter. What matters is that I have many people who know all about Foofs and who will help me if when they attack.")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_vm._v("Thank you, thank you, thank you, Erica Finkel, Susan Van Metre, Dan Santat, Pam Notarantonio, Chad Beckerman. Jen Graham, Nicole Russo, and Jason Wells.")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_vm._v("Thanks to Edward Necarsulmer IV, Andrew and Katie, the Urams, and (of course) the Beatys. Special thanks to Michael Uram, who invented the Birds and Others Classification System of Things in the Universe, which will be very useful indeed when the Foofs attack. Hint: They are Others."), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 72
// module chunks = 0